import validate from 'validate.js';
import { getErrors } from '../error/getErrors';
import { isValid } from '../error/isValid';
import { formAddEleveSchema } from '../error/schemas/formAddEleve';

export const addEleveFormErrorHandling = (eleve, field, value) => {
  let errors = eleve.errors;

  const message = validate({ [field]: value }, formAddEleveSchema);
  errors = getErrors(
    errors,
    field,
    message && message[field] && message[field][0]
  );

  return {
    ...eleve,
    values: {
      ...eleve.values,
      [field]: value
    },
    errors,
    isValid: isValid(errors)
  };
};
